import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import ClaireTour from "../components/ClaireTour";
import { useOnboardingTour } from "../hooks/useOnboardingTour";

const TourContext = createContext({ startTour: () => {}, open: false });

// Routes where the onboarding tour MUST NOT auto-open (public pages, auth flows).
const PUBLIC_ROUTES = ["/landing", "/login", "/signup"];

export function TourProvider({ children }) {
  const { open, startTour, closeTour } = useOnboardingTour();
  const location = useLocation();
  const isPublic = PUBLIC_ROUTES.some((r) => location.pathname.startsWith(r));
  // Tour is only rendered on protected/internal pages.
  const shouldShow = open && !isPublic;
  return (
    <TourContext.Provider value={{ startTour, open: shouldShow }}>
      {children}
      <ClaireTour open={shouldShow} onClose={closeTour} />
    </TourContext.Provider>
  );
}

export const useTour = () => useContext(TourContext);
